import ky from 'ky-universal';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import {
  TRACKING_EVENT__ONCLICK_BUTTON,
  TRACKING_OPERATION__CLICK,
  TRACKING_API_ENDPOINT,
} from '../../../constants';

/**
 * 傳送 onclick_button 事件：
 * 先延長或建立新的 session，
 * 將 session ID 及 metadata 傳送到後端。
 *
 * @param {object} [op_meta]
 */
async function sendClickButtonEvent(op_meta) {
  await extendOrInitSession();

  /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=1941102351} */
  const payload = {
    ...getGeneralFields(),
    event: TRACKING_EVENT__ONCLICK_BUTTON,
    op: TRACKING_OPERATION__CLICK,
    op_meta,
  };

  await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
}

import schedulePendingTasks from '../schedulePendingTasks';

export default (...args) => schedulePendingTasks(
  () => sendClickButtonEvent(...args)
);
